import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import {
  DATAFLOW_NAV_SECTIONS,
  MILKYWAY_NAV_SECTIONS,
  NAV_SECTIONS,
} from '../constants/navigation'
import { useAppMode } from '../contexts/AppModeContext'
import { useFeatureFlags } from '../contexts/FeatureFlagsContext'
import { useTenant } from '../contexts/TenantContext'
import { useCanAccess } from './useCanAccess'
import { useNavVisibility } from './useNavVisibility'
import {
  buildGlobalSearchNavItems,
  type GlobalSearchNavItem,
} from '../utils/globalSearchNav'

export function useGlobalSearchNav(): GlobalSearchNavItem[] {
  const { t } = useTranslation()
  const { isMilkyway, isDataflow } = useAppMode()
  const { isItemVisible } = useNavVisibility()
  const { canViewUI } = useCanAccess()
  const { isEnabled } = useFeatureFlags()
  const { isPlatformAdmin } = useTenant()

  return useMemo(
    () =>
      buildGlobalSearchNavItems({
        sections: isMilkyway
          ? MILKYWAY_NAV_SECTIONS
          : isDataflow
            ? DATAFLOW_NAV_SECTIONS
            : NAV_SECTIONS,
        translateLabel: (labelKey) => t(labelKey),
        isItemVisible,
        canViewUI,
        isFlagEnabled: isEnabled,
        isPlatformAdmin,
      }),
    [isMilkyway, isDataflow, t, isItemVisible, canViewUI, isEnabled, isPlatformAdmin],
  )
}
